document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", () => {
      const content = header.nextElementSibling;
      const isOpen = header.classList.contains("is-open");

      if (isOpen) {
        header.classList.remove("is-open");
        content.classList.remove("is-open");
        header.setAttribute("aria-expanded", "false");
      } else {
        header.classList.add("is-open");
        content.classList.add("is-open");
        header.setAttribute("aria-expanded", "true");
      }
    });
  });
});
